import { Button, Flex, Stack } from '@chakra-ui/react'
import type { InsuranceParamsPropertyDto } from 'BrokerTsLib/src/dtos'
import { useFormContext } from 'BrokerTsLib/src/rhf'

import { FormSection } from '@/containers/forms/FormSection'
import { useInsuranceParams } from '@/context/InsuranceParamsProvider'
import { InformationForm } from '../forms/InformationForm'

export const Information = ({
  onContinue,
  onSave,
  isLoading
}: {
  onContinue: () => Promise<any>,
  onSave: () => Promise<any>
  isLoading: boolean
}) => {
  const { formState: { errors }, getValues } = useFormContext<InsuranceParamsPropertyDto>()

  const { isDisabled } = useInsuranceParams()

  return (
    <FormSection number={3} sectionTitle="Obecné informace"
      footer={isDisabled ? undefined :
        <Stack direction='column' w='100%'>
          <Flex sx={{ w: '100%', justifyContent: 'center' }} gap={4}>
            <Button
              type="button"
              variant="solid"
              isLoading={isLoading}
              colorScheme="green"
              onClick={onContinue}
            >
              Pokračovat
            </Button>
          </Flex>
        </Stack>
      }
    >
      <InformationForm />
    </FormSection>
  )
}
